export default {
    "title": "Mi perfil",
    "adminDescription": "Conectado con el usuario <0>{{email}}</0>",
    "clientDescription": "Conectado con el usuario <0>{{email}}</0> asociado a la empresa <0>{{client}}</0>",
    "inputs": {
        "name": "Nombre *",
        "surnames": "Apellidos",
        "email": "Email *",
        "lang": "Idioma de la interfaz",
        "ref": "Periodo de referencia (inicio)",
        "currentPassword": "Contraseña actual *",
        "newPassword": "Nueva contraseña *",
        "verifyNewPassword": "Vuelve a introducir la contraseña *"
    },
    "requirements": {
        "title": "Requisitos mínimos para la nueva contraseña:",
        "characters": "Al menos 6 caracteres",
        "lower": "Una letra minúscula",
        "upper": "Una letra mayúscula",
        "number": "Un dígito numérico",
        "special": "Un caracter especial"
    },
    "lastAccess": "Últimos accesos realizados",
    "date": "Fecha y hora",
    "action": {
        "save": "Guardar",
        "changePassword": "Cambiar contraseña"
    },
    "langOptions": {
        "es": "Español",
        "en": "Inglés"
    },
    "refOptions": {
        "currentYear": "Este año",
        "lastYear": "Último año"
    },
    "validations": {
        "currentPassword": "La contraseña actual es obligatoria",
        "password": "No se cumplen todos los requisitos",
        "verifyPassword": "Las contraseñas no coinciden"
    },
    "toaster": {
        "success": {
            "updateUser": "Usuario modificado correctamente",
            "updateUserPassword": "Contraseña actualizada correctamente"
        },
        "error": {
            "updateUserPassword": "La contraseña actual no es la correcta"
        }
    }
}